import { render, staticRenderFns } from "./insurancechannel-info.vue?vue&type=template&id=20f02d22&scoped=true"
import script from "./insurancechannel-info.vue?vue&type=script&lang=js"
export * from "./insurancechannel-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f02d22",
  null
  
)

export default component.exports